import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'
import type { Customer } from '@/types'

export function useSession() {
  return useQuery({
    queryKey: ['customer', 'session'],
    queryFn: async () => {
      // The endpoint answers { customer: {...} }, NOT a { data: ... } envelope
      // (api/app/controllers/api/customer_app/sessions_controller.rb). Reading
      // .data.data returned undefined for every tenant, which is why the home
      // page showed no greeting and "no active lease" while an active lease
      // existed — and why the lease-PDF card never rendered at all.
      const response = await api.get<{ customer: Customer }>('/api/customer/session')
      return response.data.customer
    },
  })
}
